module.exports = __webpack_public_path__ + "static/img/ygfc3.f9d748e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/ygfc3.png
// module id = KkWO
// module chunks = 2